import React from 'react';
import TWConfirmModal from '../ui/tw-confirm-modal';

const ModalDelete = ({
  open,
  onCloseRequest,
  title,
  onOk,
  item,
  loading,
  text,
  shouldConfirm = false,
}) => {
  const lowered = (title || '').toLowerCase();
  const description =
    text ||
    `You're about to remove your ${lowered} and all data belong to this ${lowered}. Are you sure you want to remove "${item?.name || ''}"?`;
  const finalTitle = lowered.startsWith('delete') ? title : `Delete ${title}`;

  return (
    <TWConfirmModal
      open={open}
      onClose={onCloseRequest}
      onConfirm={() => {
        if (item?.id) onOk(item.id);
      }}
      loading={loading}
      tone="danger"
      title={finalTitle}
      description={description}
      confirmLabel="Delete"
      cancelLabel="Cancel"
      requireTypedConfirmation={shouldConfirm ? item?.name || '' : undefined}
    />
  );
};

export default ModalDelete;
